import { EnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import styles from "./EnergyLabelCTA.module.scss";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import classnames from "classnames/bind";

const cx = classnames.bind(styles);

export type EnergyLabelCTAProps = {
  className?: string;
  handleClick?: () => void;
  isLegacy: boolean;
  rating: string;
  dataComponent?: string;
  energyComboMode: boolean;
};

export const EnergyLabelCTA = ({
  className,
  handleClick,
  isLegacy,
  rating,
  dataComponent,
  energyComboMode,
}: EnergyLabelCTAProps) => {
  const classNames = cx(styles.energyLabelItem, className);

  if (energyComboMode) {
    return (
      <SecondaryButton
        className={cx("energyLabelItem", { energyComboMode })}
        size="medium"
        onClick={handleClick}
      >
        <EnergyRating
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
        <span>Energy rating</span>
      </SecondaryButton>
    );
  }

  return (
    <ListItem
      leadingIcon={
        <EnergyRating
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
      }
      trailingIcon={
        handleClick ? (
          <ArrowRight dataTestId={"energy-rating-arrow"} size="medium" />
        ) : undefined
      }
      label={
        <>
          Energy rating: <span className={styles.rating}>{rating}</span>
        </>
      }
      onClick={handleClick}
      className={styles.energyLabelItem}
      dataComponent={dataComponent}
    />
  );
};
